"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var next_components_1 = require("@dotdev/next-components");
var React = require("react");
var Snippets = require("snippets");
var Sections = require("sections");
var Footer = /** @class */ (function (_super) {
    __extends(Footer, _super);
    function Footer(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSubmit = function () {
            _this.state.email
                ? /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(_this.state.email)
                    ? (_this.context.update({
                        account: true,
                        accountStep: "register_details"
                    }),
                        _this.setState({
                            errors: false
                        }))
                    : _this.setState({
                        errors: ["Please enter a valid email address"]
                    })
                : _this.setState({
                    errors: ["Please enter an email address"]
                });
        };
        _this.footerDetails = function (settings) { return (React.createElement("div", { key: "officeAddress", className: "md:flex-1 w-full md:pb-0" }, settings.address || settings.officeemail || settings.officephone ? (React.createElement("div", { className: "w-full" },
            React.createElement("a", { className: "block leading-normal mb-2 md:pt-0 pt-2-4 font-body w-full text-arctic opacity-90 hover:opacity-100 no-underline whitespace-no-wrap transition-fast text-xs lg:text-sm tracking-wide2x font-extrabold", onClick: function () { return _this.dropdown("showDetails"); } },
                "Office Address",
                React.createElement("span", { className: "float-right text-arctic md:hidden " + (_this.state.activeDropdown && _this.state.activeDropdown == "showDetails" ? "hidden" : "inline-block") },
                    React.createElement(Snippets.Svg, { name: "plus", width: 14, className: "ml-0-2 text-arctic inline-block align-middle" })),
                React.createElement("span", { className: "float-right text-arctic md:hidden " + (_this.state.activeDropdown && _this.state.activeDropdown == "showDetails" ? "inline-block" : "hidden") },
                    React.createElement(Snippets.Svg, { name: "minus", width: 14, className: "ml-0-2 text-arctic inline-block align-middle" }))),
            React.createElement("ul", { className: "list-reset md-max-h-none overflow-hidden transition-slow md:max-h-none " + (_this.state.activeDropdown && _this.state.activeDropdown == "showDetails" ? "max-h-85" : "max-h-0") },
                settings.address ? (React.createElement("li", { className: "flex items-center mb-1-6" },
                    React.createElement("span", { className: "w-3 h-3 text-navy-dark flex justify-center items-center bg-arctic rounded-full" },
                        React.createElement(Snippets.Svg, { name: "location", width: 14 })),
                    React.createElement("p", { className: "ml-0-8 font-body font-normal text-base" }, settings.address))) : null,
                settings.officephone ? (React.createElement("li", { className: "flex items-center mb-1-6" },
                    React.createElement("span", { className: "w-3 h-3 flex justify-center items-center text-navy-dark bg-arctic rounded-full" },
                        React.createElement(Snippets.Svg, { name: "phone", width: 14 })),
                    React.createElement("p", { className: "ml-0-8 font-body font-normal text-base" }, settings.officephone))) : null,
                settings.officeemail ? (React.createElement("li", { className: "flex items-center relative md:mb-1-6 mb-2-4" },
                    React.createElement("a", { className: "absolute pin max-w-full ", href: settings.officeemail, target: "_blank", rel: "noreferrer" }),
                    React.createElement("span", { className: "w-3 h-3 flex justify-center items-center bg-arctic text-navy-dark rounded-full" },
                        React.createElement(Snippets.Svg, { name: "mail", width: 14 })),
                    React.createElement("p", { className: "ml-0-8 font-body font-normal text-base" }, settings.officeemail))) : null))) : null)); };
        _this.state = {
            email: null,
            errors: null,
            activeDropdown: null,
            scrollToTop: false
        };
        _this.handleScroll = _this.handleScroll.bind(_this);
        _this.handleEmailChange = _this.handleEmailChange.bind(_this);
        return _this;
    }
    Footer.prototype.componentDidMount = function () {
        window.addEventListener("scroll", this.handleScroll);
        window.addEventListener("resize", this.handleScroll);
    };
    Footer.prototype.componentWillUnmount = function () {
        window.removeEventListener("scroll", this.handleScroll);
        window.removeEventListener("resize", this.handleScroll);
    };
    Footer.prototype.componentDidUpdate = function () {
        this.handleScroll();
    };
    Footer.prototype.handleScroll = function () {
        var scrollToTop = this.state.scrollToTop;
        window.pageYOffset + document.body.clientHeight > document.body.scrollHeight / 2 &&
            document.body.scrollHeight > document.body.clientHeight * 2
            ? (scrollToTop = true)
            : (scrollToTop = false);
        scrollToTop != this.state.scrollToTop
            ? this.setState({
                scrollToTop: scrollToTop
            })
            : null;
    };
    Footer.prototype.scrollToTop = function () {
        event.preventDefault();
        window.scrollTo({ top: 0, behavior: "smooth" });
    };
    Footer.prototype.handleEmailChange = function (event) {
        this.setState({
            email: event.target.value,
            errors: null
        });
    };
    Footer.prototype.dropdown = function (link) {
        var newDropdown = this.state.activeDropdown === link ? null : link;
        this.setState({
            activeDropdown: newDropdown
        });
    };
    Footer.prototype.render = function () {
        var _this = this;
        var settings = this.props.section.settings;
        return (React.createElement("footer", { className: "bg-navy text-arctic" },
            React.createElement(Snippets.Container, { width: "xl", className: "mlg:px-11 pt-4 px-2-4" },
                React.createElement("div", { className: "flex flex-col xl:flex-row items-center justify-between" },
                    React.createElement("div", { className: "flex flex-wrap md:flex-row flex-col-reverse flex-1 xl:mt-0 md:pb-3-4" },
                        React.createElement("div", { className: "md:w-2/3 w-full flex flex-wrap" },
                            React.createElement(Snippets.FooterLinks, __assign({}, this.props, { linklist: this.props.data.linklist[next_components_1.ShopifyNext.Utils.getMenu(this.props.section.settings.footer_menu)], footer: this.props.section.settings })),
                            this.footerDetails(settings)),
                        React.createElement("div", { className: "md:w-1/3 md:text-left text-center md:mb-0 mb-1-6" },
                            React.createElement("p", { className: "text-xmd md:text-xmd font-body font-semibold md:leading-normal leading-none tracking-normal mb-1-6 md:mb-2-4" }, settings.subscribe_title),
                            React.createElement(Snippets.Button, { style: "chevron", className: "slick-ease-up md:mx-0 mx-auto text-md tracking-normal pl-2-4 pr-1-6 md:max-w-24 md:w-full w-7/8 pt-1-6 pb-1-2 rounded uppercase bg-arctic text-midnight hover:bg-navy-36", href: settings.subscribe_link }, settings.subscribe_link_text),
                            React.createElement("div", { className: "flex items-center pt-1-6 md:justify-start justify-center" },
                                React.createElement("p", { className: "uppercase tracking-wide2x text-sm font-body font-extrabold mr-0-8" }, "Follow Us"),
                                settings.social_icons ? (React.createElement(Snippets.SocialIcons, __assign({}, this.props, { settings: this.props.data.settings, className: "flex items-center", innerClassName: "border rounded-full h-4 w-4 mr-1-6" }))) : null))))),
            React.createElement("div", { className: "md:border-t md:border-native" }),
            React.createElement(Snippets.Container, { width: "xl", className: "pb-3-2 mlg:px-11 px-2-4" },
                React.createElement("div", { className: "flex flex-col md:flex-row md:items-center items-start justify-center md:justify-between mt-3 md:mt-1-6" },
                    React.createElement("p", { className: "block md:hidden text-xs font-body mb-0-8" }, "Welcome here"),
                    React.createElement("div", { className: "block md:hidden mb-3" }, settings.payment_icons ? React.createElement(Snippets.PaymentIcons, __assign({}, this.props)) : null),
                    React.createElement("div", { className: "hidden md:block flex-grow w-1/2" },
                        React.createElement("p", { className: "text-xs font-body mb-0-8" }, "Welcome here"),
                        React.createElement(Snippets.PaymentIcons, __assign({}, this.props))),
                    React.createElement("div", { className: "flex items-end md:flex-col flex-grow md:justify-center justify-start md:pt-1-8 w-full md:w-1/2" },
                        React.createElement("div", { className: "flex md:px-0 mobile:w-full mobile:text-center" },
                            React.createElement("p", { className: "text-xs text-arctic mobile:w-1/3" },
                                React.createElement("sup", null, "\u00A9"),
                                " ",
                                new Date().getFullYear(),
                                " ",
                                this.props.data.shop.name),
                            React.createElement(Snippets.FooterLinks, { style: "small", linklist: this.props.data.linklist[next_components_1.ShopifyNext.Utils.getMenu(this.props.section.settings.legals_menu)] }))))),
            React.createElement("div", { onClick: function (event) { return _this.scrollToTop(); }, className: "bg-navy-dark-50 text-arctic fixed pin-b pin-r group transition-fast w-5 h-5 mr-2 mb-2\n        " + (this.state.scrollToTop
                    ? "translate-y:0 opacity-100 visible pointer-events-auto"
                    : "translate-y:100 opacity-0 invisible pointer-events-none") + "\n        cursor-pointer rounded-full flex items-center justify-center hover:bg-midnight" },
                React.createElement(Snippets.Svg, { name: "arrow-up", width: 24, className: "block mr-0-1 transition-fast " + (this.state.scrollToTop ? "rotate:0" : "rotate:-45") })),
            React.createElement(Sections.PopupAccount, __assign({}, this.props, { section: this.props.data.section.subscribe, email: this.state.email }))));
    };
    Footer.sectionId = "footer";
    Footer.contextType = next_components_1.ShopifyNext.Context;
    return Footer;
}(React.PureComponent));
exports.Footer = Footer;
